import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { pathOr } from 'ramda';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Popup, Heading, Button, Emoji, Preloader } from 'components';

import classNames from 'classnames/bind';
import { closeUsisResultPopup, fetchUsisResultPopupData } from '../../actions';
import styles from './styles.pcss';
const cx = classNames.bind(styles);

const UsisResultPopup = ({
  data,
  isOpen,
  isLoading,
  actions,
  step,
}) => {
  useEffect(() => {
    if (Object.keys(data).length === 0) {
      actions.fetchUsisResultPopupData();
    }
  }, []);

  if (!isOpen) return (null);

  return (
    <Popup opened onClose={actions.closeUsisResultPopup}>
      {isLoading ? (
        <Preloader
          className={cx('preloader')}
          size="80"
        />
      ) : (
        <>
          <Emoji
            name={step === 'success' ? 'smile-pont' : 'smile-dead'}
            className={cx('emoji')}
          />

          <Heading level={1} className={cx('heading')}>
            {data[step]?.heading}
          </Heading>

          <div className={cx('description')}>
            {data[step]?.description}
          </div>

          <Button onClick={actions.closeUsisResultPopup} className={['big', cx('button')]}>
            {data[step]?.buttonText}
          </Button>
        </>
      )}
    </Popup>
  );
};

UsisResultPopup.propTypes = {
  data: PropTypes.object,
  isOpen: PropTypes.bool,
  isLoading: PropTypes.bool,
  actions: PropTypes.shape({
    closeUsisResultPopup: PropTypes.func,
    fetchUsisResultPopupData: PropTypes.func,
  }),
  step: PropTypes.string,
};

const mapStateToProps = (state) => {
  const home = pathOr({}, ['home'], state);

  return {
    isOpen: home.isUsisResultPopupOpen,
    isLoading: home.isUsisResultPopupDataFetching,
    step: home.usisResultStep,
    data: home.usisResultPopup,
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({
    closeUsisResultPopup,
    fetchUsisResultPopupData,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(UsisResultPopup);
